module.exports = __webpack_public_path__ + "img/logo.89c39f11.svg";